import React from 'react';
import css from './MemberPlanTable.module.css';

const MemberPlanTable = () => {
    return (
        <table className={css.table}>
            <thead>
                <tr>
                    <th className={css.th} colSpan="2">Member Plan</th>
                    <th className={css.th}>Value</th>
                    <th className={css.th}>Choice</th>
                    <th className={css.th}>Premium</th>
                </tr>
            </thead>
            <tbody>
                {/* Housesitter section */}
                <tr>
                    <td className={css.comboHeader} rowSpan="9">Combo</td>
                </tr>
                <tr>
                    <td className={css.sectionHeader} rowSpan="4">Housesitter</td>
                    <td className={css.subSectionHeader} colSpan="3">Cancellation // Change Fees</td>
                </tr>
                <tr>
                    <td className={css.td}>£ 0</td>
                    <td className={css.td}>£ 200 single fee<br />(Max £ 250)</td>
                    <td className={css.td}>£250 single fee<br />(Max £ 350)</td>
                </tr>
                <tr>
                    <td className={css.subSectionHeader} colSpan="3">Accommodation Expenses</td>
                </tr>
                <tr>
                    <td className={css.td}>£ 0</td>
                    <td className={css.td}>£ 50 per night<br />(Max £ 250)</td>
                    <td className={css.td}>£ 75 per night<br />(Max £ 375)</td>
                </tr>

                {/* Homeowner section */}
                <tr>
                    <td className={css.yellowSectionHeader} rowSpan="4">Homeowner</td>
                    <td className={css.yellowSubSectionHeader} colSpan="3">Cancellation // Change Fees</td>
                </tr>
                <tr>
                    <td className={css.td}>£ 0</td>
                    <td className={css.td}>£ 200 single fee<br />(Max £ 250)</td>
                    <td className={css.td}>£250 single fee<br />(Max £ 350)</td>
                </tr>
                <tr>
                    <td className={css.yellowSubSectionHeader} colSpan="3">Accommodation Expenses</td>
                </tr>
                <tr>
                    <td className={css.td}>£ 0</td>
                    <td className={css.td}>£ 50 per night<br />(Max £ 250)</td>
                    <td className={css.td}>£ 75 per night<br />(Max £ 375)</td>
                </tr>
            </tbody>
        </table>
    );
};

export default MemberPlanTable;
